import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAllUsersShort, getUsersWithApps, resetUsersWithApps, resetUsersWithAppsArray } from '../../reducers/user/duck';
import AdminAppsList from './AdminAppsList';

const mapStateToProps = ({
  userStore: {
    hasMoreUsersShort,
    pageUsersShort,
    usersShort,
    usersShortStatus,
    hasMoreUsersWithApps,
    pageUsersWithApps,
    usersWithAppsStatus,
    usersWithApps,
    sidebarStatus,
    onlyUsersWithApps,
  },
}) => ({
  hasMoreUsersShort,
  pageUsersShort,
  usersShort,
  usersShortStatus,
  hasMoreUsersWithApps,
  pageUsersWithApps,
  usersWithAppsStatus,
  usersWithApps,
  sidebarStatus,
  onlyUsersWithApps,
});

const mapDispatchToProps = {
  getAllUsersShort,
  getUsersWithApps,
  resetUsersWithApps,
  resetUsersWithAppsArray,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminAppsList));



// WEBPACK FOOTER //
// ./src/containers/AdminAppsList/index.js